const initialState = {
	isLoaded: false,
};
const resumeReducer = (state = initialState, action) => {
	switch(action.type) {
		case 'GET_RESUME':
			return Object.assign({}, {...state, isLoaded: true}, action.data);
		default:
			return state;
	};
};

export default resumeReducer;